import { jwtDecode } from "jwt-decode";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../../utils/constants";

const apiUrl = process.env.REACT_APP_DOMAIN + "/api";

const inMemoryJWTManager = () => {
  const refreshEndpoint = `${apiUrl}/admin/token/refresh`;

  const getToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

  const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

  const setToken = (accessToken, refreshToken) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    return true;
  };

  const ereaseToken = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.setItem("ra-logout", Date.now());
    return true;
  };

  const decodeToken = () => {
    try {
      const token = getToken();
      return token ? jwtDecode(token) : null;
    } catch {
      return null;
    }
  };

  const isExpired = () => {
    const decoded = decodeToken();
    if (!decoded) return true;
    return Date.now() / 1000 > decoded.exp;
  };

  const getRoles = () => decodeToken()?.roles?.[0] ?? false;
  const getId = () => decodeToken()?.userId ?? false;
  const getUserType = () => decodeToken()?.type ?? "";
  const getName = () => decodeToken()?.username ?? false;
  const getEmail = () => decodeToken()?.email ?? false;
  const hasPermissions = () => !!decodeToken();


  let refreshingPromise = null;

  const refreshAccessToken = () => {
    if (refreshingPromise) return refreshingPromise;

    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      ereaseToken();
      return Promise.reject(new Error("No refresh token"));
    }

    refreshingPromise = fetch(refreshEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: refreshToken }),
    })
        .then((res) => {
          if (!res.ok) throw new Error("Refresh failed");
          return res.json();
        })
        .then(({ data }) => {
          if (!data?.token) throw new Error("No token in response");
          setToken(data.token, data.refresh_token || data.refreshToken);
          return data.token;
        })
        .catch((err) => {
          ereaseToken();
          throw err;
        })
        .finally(() => {
          refreshingPromise = null;
        });

    return refreshingPromise;
  };

  window.addEventListener("storage", (event) => {
    if (event.key === "ra-logout") {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  });

  return {
    getToken,
    getRefreshToken,
    setToken,
    ereaseToken,
    decodeToken,
    isExpired,
    getRoles,
    getId,
    getUserType,
    getName,
    getEmail,
    hasPermissions,
    refreshAccessToken,
  };
};

export default inMemoryJWTManager();